import React from 'react';
import { DescriptionRounded } from "@mui/icons-material";
import { exportToCsv } from "../utils/csvExportUtils";

/**
 * CSV Export button configured for use in Ant Design dropdown menus
 * Returns a dropdown menu item configuration object
 */
const ExportToCsvDropdownButton = ({
                                       data,
                                       columns,
                                       fileName = 'export.csv',
                                       disabled = false,
                                       label = 'Export to CSV',
                                       icon = <DescriptionRounded />
                                   }) => {

    const handleExport = async () => {
        try {
            await exportToCsv(data, columns, fileName);
            displayToastMessage('CSV exported successfully', null, 'success');
        } catch (error) {
            console.error('Error exporting to CSV:', error);
            displayToastMessage('Failed to export CSV', null, 'error');
        }
    };

    return {
        key: 'csv',
        label: label,
        onClick: handleExport,
        icon: icon,
        disabled: disabled
    };
};

export default ExportToCsvDropdownButton;
